<template>
  <div v-if="vertical">
    <div class="text-center">
      <i :class="{ 'fas fa-check-circle text-success': status === 'successful', 'fas fa-exclamation-triangle text-danger': status === 'failed' }"></i>
      <div>
        <span class="small" v-if="status === 'successful'">{{ translate("success") }}</span>
        <span class="small" v-else-if="status === 'failed'">{{ translate("failure") }}</span>
      </div>
    </div>
  </div>
  <div v-else class="d-flex align-items-center">
    <i class="me-2" :class="{ 'fas fa-check-circle text-success': status === 'successful', 'fas fa-exclamation-triangle text-danger': status === 'failed' }"></i>
    <span class="small" v-if="status === 'successful'">{{ translate("success") }}</span>
    <span class="small" v-else-if="status === 'failed'">{{ translate("failure") }}</span>
  </div>
</template>

<script>
export default {
  name: "AutomationLogStatus",
  props: {
    status: String,
    vertical: Boolean
  }
}
</script>

<style scoped>

</style>